import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] } }),
};

export const Reveal = ({ children, className = "", i = 0, id }) => (
  <motion.div
    id={id}
    variants={fadeUp}
    custom={i}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <span className="inline-flex items-center gap-2 text-[#3A2718] text-xs font-semibold uppercase tracking-[0.2em] mb-4">
    <span className="w-8 h-px bg-[#3A2718]" />
    {children}
  </span>
);

export const Intro = () => {
  const { t } = useLang();
  const c = t.intro;
  return (
    <section className="relative py-24 md:py-32 bg-[#F6F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-5">
            <Reveal>
              <SectionLabel>{c.label}</SectionLabel>
              <h2 className="font-display font-bold text-4xl sm:text-5xl leading-[1.05] text-[#1A1C19]">
                {c.heading}
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-7 md:pt-2">
            <Reveal i={1}>
              <p className="text-[#4A4D48] text-lg leading-relaxed">{c.p1}</p>
              <p className="mt-6 text-[#4A4D48] text-lg leading-relaxed">
                {c.p2a}<span className="text-[#1F5A34] font-semibold">{c.p2b}</span>{c.p2c}<span className="text-[#1F5A34] font-semibold">{c.p2d}</span>{c.p2e}
              </p>
              <p className="mt-8 font-display text-2xl font-bold text-[#1F5A34]">{c.tagline}</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
